import React, { useEffect } from "react";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

import { Dialog } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logOutUser } from "../../../store/actions/authAction";
import SocketContext from "../../../function/SocketContext";
import isEmpty from "../../../store/validation/is-Empty";

function Relogin(props) {
  // const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = React.useState(false);

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth : "";
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (props?.open) {
      handleClickOpen();
    }
  }, [props?.open]);


  useEffect(() => {
    props.socket.service("vendor-user").on("adminLogin", (data) => {
      if (data?.userId === auth?.user?.VendorUser?.userId && data?.OTP !== auth?.user?.VendorUser?.OTP) {
        setOpen(true);
      }
    });
  }, [props.socket])

  const handleClose = () => {
    setOpen(false);
  };

  const adminLogin = () => {
    dispatch(logOutUser())
    handleClose()
    history.push('/admin-login')
  }


  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent className="text-center">
          <DialogContentText id="alert-dialog-description">
            <div className="f16-700">Alert!</div>
            <div className="mt-2 f12-400">
              Another session has been initiated, with same User ID.
            </div>
            <div className="mt-3">
              <ButtonReusableComponent
                buttonText="Login"
                buttonType="Submit"
                buttonClass={"activeLogin"}
                onClick={adminLogin}
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const ReloginComponent = (props) => (
  <SocketContext.Consumer>
    {(socket) => <Relogin {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default ReloginComponent;

